var map = {
	"./base-waterfall.vue": [
		"I4+x",
		0
	],
	"./graduation-wall.vue": [
		"5cRN",
		0,
		22
	],
	"./student-feedback.vue": [
		"760u",
		0,
		21
	],
	"./wish-wall.vue": [
		"m+rh",
		0,
		20
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "yKWf";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/components/znc-school/student-style lazy ^\.\/.*\.vue$
// module id = yKWf
// module chunks = 24